import { CintTheme } from '@lucidhq/lucidium';

export const theme = {
  ...CintTheme,
  colors: {
    ...CintTheme.colors,
    secondary: '#40C950; color: #000000',
    secondary100: '#EDFDEE',
    secondary200: '#ACECB4',
    secondary400: '#63D470',
    secondary500: '#40C950',
    secondary600: '#30AB41',
    secondary700: '#136720',
  },
};
